import * as routes from 'api/routes';
import { IModel } from 'models/faq/interface';

export type Params = Omit<IModel, '_id'>;
export type Result = Array<IModel>;

export const ROUTE = routes.FAQ_GET;
export const WEBSITE_ROUTE = routes.FAQ_WEBSITE_GET;
